export default "__VITE_ASSET__BDkfGeY5__"